import { render, staticRenderFns } from "./deviceFunAuxLight.vue?vue&type=template&id=3d5b78a0&"
import script from "./deviceFunAuxLight.vue?vue&type=script&lang=js&"
export * from "./deviceFunAuxLight.vue?vue&type=script&lang=js&"
import style0 from "./deviceFunAuxLight.vue?vue&type=style&index=0&id=3d5b78a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports